import { render, staticRenderFns } from "./box.html?vue&type=template&id=0fe7ccb0&scoped=true&external"
import script from "./box.js?vue&type=script&lang=js&external"
export * from "./box.js?vue&type=script&lang=js&external"
import style0 from "./box.scss?vue&type=style&index=0&id=0fe7ccb0&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe7ccb0",
  null
  
)

export default component.exports